module.exports = __webpack_public_path__ + "img/Motor_saf_1.c720deec.jpg";